import { Center, Heading, Stack } from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ButtonLink, NavBar } from "@src/components/ui-kit";
import { ErrorIcon, Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { MainLayout } from "@src/components/widgets/Layout";
import { getQueryParamOptional } from "@src/utils/routing";
import { createFileRoute } from "@tanstack/react-router";
import { useRouter } from "next/router";

function Page() {
  const { query } = useRouter();
  const bankStatus = getQueryParamOptional("paired-bank", query);
  const pipedriveStatus = getQueryParamOptional("paired-pipedrive", query);
  const pairingSuccessful =
    bankStatus === "success" || pipedriveStatus === "success";

  return (
    <MainLayout
      title={t`Settings`}
      navigation={
        <AppSubNav>
          <NavBar.BackButton defaultUrl="/" />
        </AppSubNav>
      }
      withNavigationBorder
    >
      <Center flexDir="column" mt="8">
        <Heading size="xl">
          <Stack
            alignItems="center"
            flexDir={{
              base: "column",
              md: "row",
            }}
          >
            {pairingSuccessful ? (
              <>
                <Icon name="check-circle" color="green.500" boxSize="32" />
                &nbsp;
                <Trans>Pairing successful</Trans>
              </>
            ) : (
              <>
                <ErrorIcon boxSize="32" />
                &nbsp;
                <Trans>Pairing failed, please try again later.</Trans>
              </>
            )}
          </Stack>
        </Heading>
        <ButtonLink href="/" mt="12">
          <Trans>Go to home page</Trans>
        </ButtonLink>
      </Center>
    </MainLayout>
  );
}

export const Route = createFileRoute("/settings")({
  component: Page,
});
